import DtoCallbackOrderFiles_File from "./DtoCallbackOrderFiles_File";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoCallbackOrderFiles {
    constructor() {
        //无参构造函数
        this.PoolIds = [];
        this.Files = [];
    }

    [proName: string]: any;
    /**
     * 
     */
    OrderId?: string;
    /**
     * 
     */
    PoolId?: string;
    /**
     * 
     */
    PoolIds?: string[];
    /**
     * 场景
     */
    Scene?: string;
    /**
     * 订单Id
     */
    Files?: DtoCallbackOrderFiles_File[];
}

/**
 * -表单校验
 */
export const DtoCallbackOrderFilesRules = {
    Scene: [
        {
            max: 256,
            message: "文本长度不能超过 256 个字符",
            trigger: "blur",
        },
    ],
}
